import { useId } from 'react';

import { GlassLink } from '@components/glass/GlassButton';
import { GlassSurface } from '@components/glass/GlassSurface';
import { PRIMARY_CTA, SITE } from '@config/site';

import styles from './CtaPanel.module.scss';

/** The closing invitation at the foot of every page but Contact. */
export const CtaPanel = () => {
  const headingId = useId();

  return (
    <section className={styles.section} aria-labelledby={headingId}>
      <GlassSurface variant="regular" className={styles.panel} data-reveal="">
        <div className={styles.glow} aria-hidden="true" />
        <h2 id={headingId} className={styles.title}>
          Have something <em>ambitious</em> in mind?
        </h2>
        <p className={styles.lede}>
          Tell us what you are building, and we will come back with questions, a rough plan and
          clear next steps.
        </p>
        <div className={styles.actions}>
          <GlassLink to={PRIMARY_CTA.to} tone="primary" size="lg" icon="arrowRight">
            {PRIMARY_CTA.label}
          </GlassLink>
          <GlassLink to={`mailto:${SITE.email}`} size="lg" icon="mail">
            {SITE.email}
          </GlassLink>
        </div>
      </GlassSurface>
    </section>
  );
};
